import React from "react";
import {Tag} from "antd";
import {SHIFT_STATUSES, toShiftStatusLabel} from "../../../constants/shiftStatuses";

// Operasyon Yönetimi vardiyalar tablosundaki etiketle aynı görünüm: kenarlıklı, 8px radius,
// sabit genişlik — "Giriş Yapılmadan Tamamlandı" gibi uzun durumlar iki satıra sarabilsin diye.
export const ShiftStatusTag = ({status}) => {
    const label = toShiftStatusLabel(status);
    const style = label && SHIFT_STATUSES[label];

    if (!style) return <span>-</span>;

    return (
        <Tag
            style={{
                background: style.background,
                color: style.color,
                borderColor: style.border,
                height: "auto",
                minHeight: 24,
                width: 150,
                borderRadius: 8,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "13px",
                padding: "4px 8px",
                whiteSpace: "normal"
            }}
        >
            {label}
        </Tag>
    );
};

export default ShiftStatusTag;
